const fa = {
    rtl: false,
    name: 'فارسی',
    msg:{
        "mainTitle" : 'سلاااااام :)'
    }
}

export default fa;